module.exports = __webpack_public_path__ + "static/Flavor_18AMT90217-b6360a5de76d399df7e18fcc5d8f70f6.pdf";